<div class="relative">
  <div
    class="scroll-down bounce"
    *ngIf="!tosScrolled"
    (click)="scrollContainer.scrollTop = scrollContainer.scrollHeight"
  >
    <svg
      width="12"
      height="8"
      viewBox="0 0 12 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.41 0.294998L6 4.875L10.59 0.294998L12 1.705L6 7.705L0 1.705L1.41 0.294998Z"
        fill="#fff"
        fill-opacity="1"
      />
    </svg>
  </div>
  <div class="scroll-container" (scroll)="onScroll($event)" #scrollContainer>
    <h2>{{ termsOfService.agb_caption | i18next }}</h2>
    <p [innerHTML]="termsOfService.agb_content | i18next"></p>
  </div>
</div>

<div class="margin-2">
  <button
    class="btn primary full disabled"
    [ngClass]="{ disabled: !tosScrolled || !termsOfService?.version }"
    [disabled]="!tosScrolled || !termsOfService?.version"
    (click)="termsAccepted()"
  >
    {{ "tos.accept" | i18next }}
  </button>
</div>
